import React, { useState } from "react";
import { FaCamera, FaFilm, FaCameraRetro, FaImage } from 'react-icons/fa';

const Services = () => {
  const [sectionTitle] = useState("We Offer The Best Quality Service for You");
  const [sectionTitleText] = useState(
    "Our team is dedicated to delivering high-quality and creative services to capture your most precious moments, making them timeless."
  );

  // Inline styles for the individual service items
  const serviceItemStyle = {
    background: "#fff",  // Add background for better visibility
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.6)",
    textAlign: "center",
  };

  const iconStyle = {
    fontSize: "40px",
    marginBottom: "10px",
  };

  return (
    <div>
      <section className="services-section">
        {/* Section Title */}
        <div className="animate_top bb ze rj ki xn vq">
          <h2 className="fk vj pr kk wm on/5 gq/2 bb _b">{sectionTitle}</h2>
          <p className="bb on/5 wo/5 hq">{sectionTitleText}</p>
        </div>

        {/* Service Items */}
        <div className="bb ze ki xn yq mb en">
          <div className="services-grid">
            {/* Service Item */}
            <div style={serviceItemStyle} className="animate_top sg oi pi zq ml il am cn _m service-item">
              <FaCamera style={iconStyle} className="service-icon" />
              <h4 className="ek zj kk wm _b">Premium Pre Wedding</h4>
              <p>
                Our pre-wedding photography services focus on capturing your love story before the big day. From candid moments to creative shoots, we make sure the journey leading up to your wedding is just as memorable as the day itself.
              </p>
            </div>

            {/* Service Item */}
            <div style={serviceItemStyle} className="animate_top sg oi pi zq ml il am cn _m service-item">
              <FaCameraRetro style={iconStyle} className="service-icon" />
              <h4 className="ek zj kk wm _b">Premium Wedding</h4>
              <p>
                Our wedding photography and videography services are designed to capture every special moment. From emotional exchanges to beautiful portraits, we ensure every second of your wedding day is immortalized perfectly.
              </p>
            </div>

            {/* Service Item */}
            <div style={serviceItemStyle} className="animate_top sg oi pi zq ml il am cn _m service-item">
              <FaFilm style={iconStyle} className="service-icon" />
              <h4 className="ek zj kk wm _b">Cinematic Films</h4>
              <p>
                Let us tell your story through the art of cinematic filming. With our advanced video techniques and creative storytelling, we capture the essence of your event in a beautiful cinematic style that you'll treasure forever.
              </p>
            </div>

            {/* Service Item */}
            <div style={serviceItemStyle} className="animate_top sg oi pi zq ml il am cn _m service-item">
              <FaImage style={iconStyle} className="service-icon" />
              <h4 className="ek zj kk wm _b">Model Portfolio</h4>
              <p>
                We offer professional portfolio services for models, helping you showcase your best looks through stunning photography. Whether you're building your first portfolio or updating an existing one, we provide expert guidance and creative direction.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Add CSS for mobile responsiveness */}
      <style>
        {`
          /* Default grid layout for larger screens */
          .services-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);  /* 4 equal columns */
            gap: 20px;
            margin-top: 20px;
          }

          /* Mobile-specific styling */
          @media (max-width: 768px) {
            .services-grid {
              grid-template-columns: repeat(2, 1fr); /* 2 columns for tablets */
            }
          }

          @media (max-width: 480px) {
            .services-grid {
              grid-template-columns: 1fr; /* 1 column for mobile */
            }

            .service-item {
              padding: 15px; /* Decrease padding on mobile for better fit */
            }

            .service-icon {
              font-size: 30px; /* Smaller icons for mobile */
            }

            .section-title {
              font-size: 24px; /* Adjust font size for mobile */
            }

            .section-text {
              font-size: 14px; /* Adjust font size for mobile */
            }
          }
        `}
      </style>
    </div>
  );
};

export default Services;
